import { ArrowLeft, MapPin, Calendar, Users, Plane, Utensils, Mountain, Wine, Camera } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CHILE_HERO = 'https://images.unsplash.com/photo-1515767513519-e50caaf922e3';
const CHILE_IMAGES = {
  day1: 'https://images.pexels.com/photos/37136626/pexels-photo-37136626.jpeg',
  day2: 'https://images.pexels.com/photos/106037/pexels-photo-106037.jpeg',
  day3: 'https://images.pexels.com/photos/34004193/pexels-photo-34004193.jpeg',
  day4: 'https://images.pexels.com/photos/13641027/pexels-photo-13641027.jpeg',
  day5: 'https://images.pexels.com/photos/17808457/pexels-photo-17808457.jpeg',
  day6: 'https://images.pexels.com/photos/26990547/pexels-photo-26990547.jpeg',
};

export default function Chile() {
  const navigate = useNavigate();

  const days = [
    { day: 1, title: 'Santiago: City Tour & Gastronomia', description: 'Chegada VIP e exploração da capital chilena',
      highlights: [
        { icon: Plane, label: 'Chegada VIP', detail: 'Transfer privativo do aeroporto para hotel em Providência ou Las Condes' },
        { icon: MapPin, label: 'Centro Histórico', detail: 'Exploração da Plaza de Armas e arquitetura clássica da capital chilena' },
        { icon: Mountain, label: 'Cerro San Cristóbal', detail: 'Vista panorâmica da cidade com a Cordilheira dos Andes ao fundo' },
        { icon: Camera, label: 'Sky Costanera', detail: 'Mirante mais alto da América Latina para um pôr do sol inesquecível' },
      ],
      highlight: 'Encerre seu primeiro dia com um jantar exclusivo em um restaurante de alta gastronomia com vista privilegiada para os Andes iluminados.' },
    { day: 2, title: 'Valle Nevado: A Magia dos Andes', description: 'Experiência na neve em um dos resorts mais icônicos do mundo',
      highlights: [
        { icon: Mountain, label: 'Ski & Snowboard', detail: 'Tubing na neve - diversão garantida nas pistas' },
        { icon: Utensils, label: 'Almoço nas Montanhas', detail: 'Refeição gourmet com vista para os picos nevados' },
        { icon: Camera, label: 'Teleférico Panorâmico', detail: 'Vistas espetaculares da Cordilheira' },
        { icon: Camera, label: 'Ensaios Fotográficos', detail: 'Paisagens nevadas - momentos inesquecíveis' },
      ],
      highlight: 'Prepare-se para o dia mais esperado da viagem: uma imersão completa na neve em um dos resorts mais icônicos do mundo.' },
    { day: 3, title: 'Vale do Maipo: Safari de Vinhos', description: 'Experiência sensorial com vinhos premium',
      highlights: [
        { icon: Wine, label: 'Vinícolas de Prestígio', detail: 'Tour exclusivo pelas famosas Concha y Toro e Santa Rita, explorando caves subterrâneas lendárias' },
        { icon: Wine, label: 'Degustação Premium', detail: 'Apreciação de rótulos selecionados e vinhos ícones guiada por sommeliers' },
        { icon: Utensils, label: 'Almoço Harmonizado', detail: 'Gastronomia de alto nível integrada aos parreirais, com pratos desenhados para realçar cada vinho' },
      ],
      highlight: 'Uma experiência que une tradição, sabor e paisagem em perfeita harmonia.' },
    { day: 4, title: 'Cajón del Maipo: Natureza Pura', description: 'Imersão na natureza selvagem da Cordilheira',
      highlights: [
        { icon: Mountain, label: 'Trilhas Naturais', detail: 'Caminhadas pelos cânions e vales selvagens' },
        { icon: MapPin, label: 'Paisagens Selvagens', detail: 'Contato direto com a natureza intocada' },
        { icon: Utensils, label: 'Piquenique Premium', detail: 'Refeição ao ar livre com vista para as montanhas' },
      ],
      highlight: 'Descubra a verdadeira essência dos Andes em sua forma mais selvagem e pura.' },
    { day: 5, title: 'Litoral: Valparaíso & Viña del Mar', description: 'Beleza costeira e vida marinha',
      highlights: [
        { icon: MapPin, label: 'Valparaíso', detail: 'Exploração da cidade portuária com suas ruas coloridas e arquitetura histórica' },
        { icon: Camera, label: 'Viña del Mar', detail: 'Praias de areia branca e resorts de luxo' },
        { icon: Utensils, label: 'Frutos do Mar Premium', detail: 'Degustação de frutos do mar frescos em restaurante à beira-mar' },
      ],
      highlight: 'Contraste perfeito entre a montanha e o mar - dois mundos em um só destino.' },
    { day: 6, title: 'Rancagua: Parque Safari Chile', description: 'Encontro com a vida selvagem chilena',
      highlights: [
        { icon: Mountain, label: 'Safari Chile', detail: 'Experiência única com animais em habitat natural' },
        { icon: Camera, label: 'Fotografia de Vida Selvagem', detail: 'Capture momentos únicos com a fauna local' },
        { icon: Plane, label: 'Retorno', detail: 'Transfer para o aeroporto com memórias inesquecíveis' },
      ],
      highlight: 'Encerre sua jornada com um encontro inesquecível com a natureza selvagem do Chile.' },
  ];

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <div className="relative h-96 bg-cover bg-center flex items-center justify-center" style={{ backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.3) 100%), url('${CHILE_HERO}')` }}>
        <div className="text-center text-white z-10">
          <h1 className="text-5xl md:text-6xl font-bold mb-4 text-white">ROTEIRO CHILE</h1>
          <p className="text-xl md:text-2xl font-light">Uma Experiência Única nos Andes</p>
        </div>
      </div>

      <div className="container py-6">
        <button onClick={() => navigate('/#destinations')} className="flex items-center gap-2 text-primary hover:text-accent transition-colors font-semibold">
          <ArrowLeft size={20} />
          Voltar aos Destinos
        </button>
      </div>

      <section className="py-12 bg-slate-50">
        <div className="container">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              Uma jornada desenhada para unir o luxo urbano de Santiago à imensidão selvagem da Cordilheira e a conexão com a vida animal.
            </p>
            <div className="grid grid-cols-3 gap-4 mt-8">
              <div className="flex flex-col items-center"><Calendar className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">10 Dias</p></div>
              <div className="flex flex-col items-center"><Users className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">A partir de 2 pessoas</p></div>
              <div className="flex flex-col items-center"><Plane className="text-accent mb-2" size={32} /><p className="font-semibold text-primary">Tudo Incluído</p></div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 flex-1">
        <div className="container">
          <h2 className="text-4xl font-bold text-center mb-16 text-primary">SEU CRONOGRAMA PREMIUM</h2>
          <div className="space-y-12">
            {days.map((dayInfo, index) => (
              <div key={dayInfo.day} className="fade-in-up" style={{ animationDelay: `${index * 80}ms` }}>
                <div className="grid md:grid-cols-2 gap-8 items-start">
                  <div>
                    <div className="inline-block px-4 py-2 bg-accent/10 border border-accent/30 rounded-full mb-4">
                      <p className="text-accent font-bold text-sm">DIA {dayInfo.day}</p>
                    </div>
                    <h3 className="text-3xl font-bold text-primary mb-2">{dayInfo.title}</h3>
                    <p className="text-muted-foreground text-lg mb-6">{dayInfo.description}</p>
                    <div className="space-y-4 mb-6">
                      {dayInfo.highlights.map((h, idx) => {
                        const Icon = h.icon;
                        return (
                          <div key={idx} className="flex gap-4">
                            <div className="flex-shrink-0"><Icon className="text-accent" size={24} /></div>
                            <div>
                              <p className="font-semibold text-primary">{h.label}</p>
                              <p className="text-muted-foreground text-sm">{h.detail}</p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="bg-accent/5 border-l-4 border-accent p-4 rounded">
                      <p className="text-primary font-semibold italic">“{dayInfo.highlight}”</p>
                    </div>
                  </div>
                  <div className="rounded-lg h-96 overflow-hidden shadow-lg">
                    <img src={CHILE_IMAGES[`day${dayInfo.day}`]} alt={dayInfo.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
                  </div>
                </div>
                {index < days.length - 1 && <hr className="my-12 border-slate-200" />}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-primary text-white">
        <div className="container text-center">
          <h2 className="text-4xl font-bold mb-4 text-white">Pronto para Viver Esta Experiência?</h2>
          <p className="text-lg mb-8 text-white/90">Entre em contato conosco e customize seu roteiro</p>
          <a href="https://wa.me/5548991904829?text=Olá! Gostaria de orçar o roteiro premium do Chile." target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-white text-primary font-bold rounded-full hover:bg-slate-100 transition-colors">
            Solicitar Orçamento via WhatsApp
          </a>
        </div>
      </section>

      <section className="py-8 bg-slate-50">
        <div className="container text-center text-muted-foreground text-sm">
          <p>PROPOSTA EXCLUSIVA | 2026</p>
          <p>@jmtravel.oficial | CNPJ 64.418.580/0001-14</p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
